var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "main" } },
    [
      _c("h2", { attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.$t("UserManagement.ChangeEmail.Title")))
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(_vm.$t("UserManagement.ChangeEmail.Description"))
        }
      }),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "changeEmailObserver",
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                _c(
                  "form",
                  {
                    staticClass: "mb-5",
                    attrs: { id: "changeEmailForm" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.changeEmail(invalid, errors)
                      }
                    }
                  },
                  [
                    _c("text-input-row", {
                      attrs: {
                        title: "UserManagement.ChangeEmail.NewEmail",
                        id: "change-email-email",
                        required: true,
                        maxLength: _vm.emailMaxLength,
                        rules: _vm.emailRules,
                        providerName: "newEmail",
                        providerMode: "aggressive"
                      },
                      model: {
                        value: _vm.newEmail,
                        callback: function($$v) {
                          _vm.newEmail = $$v
                        },
                        expression: "newEmail"
                      }
                    }),
                    _vm._v(" "),
                    _c("text-input-row", {
                      attrs: {
                        title: "UserManagement.ChangeEmail.ConfirmEmail",
                        id: "change-email-confirm-email",
                        required: true,
                        maxLength: _vm.emailMaxLength,
                        rules: _vm.confirmEmailRules,
                        providerMode: "aggressive"
                      },
                      model: {
                        value: _vm.confirmEmail,
                        callback: function($$v) {
                          _vm.confirmEmail = $$v
                        },
                        expression: "confirmEmail"
                      }
                    }),
                    _vm._v(" "),
                    _c("text-input-row", {
                      attrs: {
                        title: "UserManagement.ChangeEmail.Password",
                        id: "change-email-password",
                        type: "password",
                        required: true,
                        providerMode: "aggressive"
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-8 col-lg-9 offset-md-4 offset-lg-3"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: {
                                type: "submit",
                                disabled: _vm.updating,
                                "aria-disabled": _vm.updating
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("UserManagement.ChangeEmail.Update")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }